import type { Action } from 'state/actions';

import type { AppCrashState } from './appCrash.model';
import { appCrashInitialState } from './appCrash.model';

export function appCrashReducer(state: AppCrashState = appCrashInitialState, action: Action): AppCrashState {
  switch (action.type) {
    case 'APP_CRASHED':
      return {
        isCrashed: true,
        technicalErrorMessage: action.technicalErrorMessage,
        cause: action.error,
        isAutomaticEmailSent: action.sendAutomaticEmail,
      };

    default:
      return state;
  }
}
